import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getFinancingTypesService from '../../services/financingType/getFinancingTypes'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchFinancingTypeSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchFinancingTypes ({ financialInstitutionId, page }) {
  try {
    yield put(commonActions.showLoader())
    yield put(fetchFinancingTypeSuccess(null, page))
    const auth = yield select(getAuth)
    const financingTypeList = yield call(getFinancingTypesService, financialInstitutionId, auth.token)
    yield put(fetchFinancingTypeSuccess(financingTypeList, page))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchFinancingTypes () {
  yield takeLatest(combosActionTypes.FETCH_FINANCING_TYPE, fetchFinancingTypes)
}
